import { isSportsbookHistoryDecimalString } from '../contracts/sportsbookHistoryResponse.contract.js';
import { formatSportsbookHistoryMoney, formatSportsbookHistoryOdds } from './sportsbookHistoryDecimal.display.js';

const decimal = value => {
  const text = value == null ? '' : String(value);
  return isSportsbookHistoryDecimalString(text) && !text.startsWith('-') ? text : null;
};
const aboveOne = value => {
  const [integer, fraction = ''] = value.split('.');
  return integer !== '0' && (integer !== '1' || /[1-9]/.test(fraction));
};
const part = value => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return null;
  const multiplier = decimal(value.multiplier), amount = decimal(value.bonus_amount);
  if (multiplier == null || amount == null || !Number.isSafeInteger(value.eligible_leg_count)
    || value.eligible_leg_count < 0) return null;
  return { multiplier, bonus_amount: amount };
};
const TERMINAL = /^(WON|LOST|VOID|CANCELLED|CANCELED|CASHOUT|HALF_WIN|HALF_LOSE|HALF_LOSS|PARTIAL_WON|PARTIAL_LOST|REJECTED|FAILED)$/i;

/** Present the server-recorded tier, never derive it from counts, odds or payout. */
export const getHistoryBonusDisplay = (bonus, status) => {
  const settled = part(bonus?.settlement);
  const selected = settled ?? (TERMINAL.test(status ?? '') ? null : part(bonus?.accepted));
  if (!selected || !aboveOne(selected.multiplier) || !/[1-9]/.test(selected.bonus_amount)) return null;
  return {
    label: `보너스 ×${formatSportsbookHistoryOdds(selected.multiplier)}`,
    title: `${settled ? '정산' : '예상'} 보너스 배율 ×${selected.multiplier} · 보너스 금액 ${formatSportsbookHistoryMoney(selected.bonus_amount)}원 · 금액은 상한/반올림 반영 · 총배당에 포함`,
  };
};
